import {h, Component, Fragment, createRef} from 'preact';
import PropTypes from 'prop-types';

const STAGE_PREPARE = 'prepare';
const STAGE_CONFIRMING = 'confirming';
const SCANNING_TIMEOUT = 10;

const constraints = {
	width: {min: 640, ideal: 1080},
	height: {min: 480, ideal: 720},
	advanced: [
		{width: 1440, height: 1080},
		{aspectRatio: 1.333},
		{frameRate: {max: 30}},
	]
};

class CameraInput extends Component {
	constructor(props){
		super(props);

		this.videoRef = createRef();

		this.initScanningPrepareTimer = null;

		this.imageCapture = null;

		this.state = {
			file: null,
			fileDataUrl: null,

			scanningStage: null,
			scanningPrepareSeconds: null,
		}
	}

	initScanningPrepare(){
		this.stopScanningPrepareTimer();

		this.setState({scanningStage: STAGE_PREPARE});
		window.navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
			const video = this.videoRef.current;
			video.srcObject = stream;

			const track = stream.getVideoTracks()[0];
			track.applyConstraints(constraints)
				.then(() => {
					this.imageCapture = new ImageCapture(track);
				})
				.catch(e => {
					console.log('---', e);
				});


			video.onloadedmetadata = e => {
				video.play();
				this.setState({scanningPrepareSeconds: SCANNING_TIMEOUT});
				let timePrepare = SCANNING_TIMEOUT;
				this.initScanningPrepareTimer = setInterval(() => {
					--timePrepare;
					this.setState({scanningPrepareSeconds: timePrepare});
					if(timePrepare <= 0)
					{
						this.endScanning();
					}
				}, 1000);
			};
		}).catch(error => {
			alert('Что-то не так с видеостримом или не дали разрешение!');
			console.log('---', error);
		});
	}

	stopScanningPrepareTimer(){
		if(this.initScanningPrepareTimer)
		{
			clearInterval(this.initScanningPrepareTimer);
		}
	}

	endScanning(){
		this.stopScanningPrepareTimer();

		this.imageCapture.takePhoto()
			.then(blob => {
				blob.name = 'photo.png';
				this.setState({file: blob});
				return createImageBitmap(blob)
			})
			.then(imageBitmap => {
				this.setState({fileDataUrl: imageBitmap});
				const canvas = document.querySelector('#canvas-photo');
				this.drawCanvas(canvas, imageBitmap);
			})
			.catch(error => console.log(error));

		this.setState({scanningStage: STAGE_CONFIRMING});
	}
	confirmScanning(){
		this.setState({scanningStage: null});
		this.onChange(this.state.file, this.state.fileDataUrl);
	}

	rejectScanning(){
		this.setState({
			scanningStage: null,
			scanningPrepareSeconds: null,
			file: null,
			fileDataUrl: null,
		});
	}

	onChange(file, fileDataUrl){
		if(this.props.onChange)
		{
			this.props.onChange(file, fileDataUrl);
		}
	}

	drawCanvas(canvas, img) {
		canvas.width = 887;
		canvas.height = 666;
		let ratio  = Math.min(canvas.width / img.width, canvas.height / img.height);
		let x = (canvas.width - img.width * ratio) / 2;
		let y = (canvas.height - img.height * ratio) / 2;
		canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
		canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height,
			x, y, img.width * ratio, img.height * ratio);
	}

	drawTimer()	{
		const time = this.state.scanningPrepareSeconds;
		const minute = Math.floor(time/60);
		let seconds = time - (minute * 60);
		seconds = seconds > 9 ? seconds : '0' + seconds;

		return minute + ':' + seconds;
	}

	render(){
		const {fileDataUrl, scanningStage, scanningPrepareSeconds} = this.state;

		return (
			<div>
				{scanningStage === null && (
					<Fragment>
						<div className="modal-photo__head">
							<h2 className="modal-photo__title">Фото документа</h2>
							<h3 className="modal-photo__subtitle">Как сфотографировать документ?</h3>
						</div>
						<div className="modal-photo__body">
							<div className="modal-photo__item">
								<div className="modal-photo__number">1</div>
								<div className="modal-photo__text">Нажмите на кнопку «Включить камеру и сканировать». Появится окно с изображением и запустится таймер на {SCANNING_TIMEOUT} секунд.</div>
								<div className="modal-photo__item-container">
									<div className="modal-photo__item-img"/>
									<div className="modal-photo__item-stage">00:{SCANNING_TIMEOUT}</div>
								</div>
							</div>
							<div className="modal-photo__item">
								<div className="modal-photo__number">2</div>
								<div className="modal-photo__text">Поднесите документ к камере так, чтобы он занимал всю зону кадра. Держите его в таком положении пока не закончится обратный отсчёт.</div>
								<div className="modal-photo__item-container">
									<div className="modal-photo__item-img"/>
									<div className="modal-photo__item-stage">00:{SCANNING_TIMEOUT}</div>
								</div>
							</div>
							<div className="modal-photo__item">
								<div className="modal-photo__number">3</div>
								<div className="modal-photo__text">Камера автоматически сфотографирует лист.Вы сможете повторить съемку, если это необходимо.</div>
								<div className="modal-photo__item-container">
									<div className="modal-photo__item-img"/>
									<div className="modal-photo__item-stage"/>
								</div>
							</div>
						</div>
						<div className="modal-photo__footer">
							<p className="modal-photo__prompt">Можно будет отменить если не получилось</p>
							<button className="modal-photo__button" type='button' onClick={e => this.initScanningPrepare()}>Включить камеру и сфотографировать</button>
						</div>
					</Fragment>
				)}

				{scanningStage === STAGE_PREPARE && (
					<div className='modal-photo_step-2'>
						<div className="modal-photo__head">
							<h2 className="modal-photo__title">Фото документа</h2>
						</div>
						<div className="modal-photo__body">
							<div className="modal-photo__img-container"><video ref={this.videoRef} width={'887'}/></div>
						</div>
						<div className="modal-photo__footer">
							<p className="modal-photo__prompt">Поднесите документ к камере так, чтобы он занимал всю зону кадра. Держите его в таком положении пока не закончится обратный отсчёт</p>
							<div className="modal-photo__timer">{this.drawTimer()}</div>
						</div>
					</div>
				)}

				{scanningStage === STAGE_CONFIRMING && (
					<div className='modal-photo_step-3'>
						<div className="modal-photo__head">
							<h2 className="modal-photo__title">Фото документа</h2>
						</div>
						<div className="modal-photo__body">
							<div className="modal-photo__img-container">
								<canvas id='canvas-photo'/>
							</div>
						</div>
						<div className="modal-photo__footer">
							<button className="modal-photo__button" onClick={e => this.confirmScanning()} type='button'>Использовать этот снимок</button>
							<button className="modal-photo__button modal-photo__button_dark" type='button'  onClick={e => this.rejectScanning()}>Повторить ещё раз</button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

CameraInput.propTypes = {
	onChange: PropTypes.func,
}

export default CameraInput;
